export var remCalc = function (px) { return 0.0625 * px + "rem"; };
